import type { UseHttp } from '~/api/interface'

export const fetchEditUserInfo: UseHttp = (params, option) => {
  return useHttp.post('/api/user/editInfo', params, { ...option })
}

export const fetchMyIndustry: UseHttp = (params, option) => {
  return useHttp.get('/api/user/myIndustry', undefined, { ...option })
}

export const fetchEditMyIndustry: UseHttp = (params, option) => {
  return useHttp.post('/api/user/myIndustry/edit', params, { ...option })
}

export const fetchUserInfo: UseHttp = (params, option) => {
  return useHttp.get('/api/user/getInfo', undefined, { ...option })
}

export const fetchCheckUserExist: UseHttp = (params, option) => {
  return useHttp.get(`/api/user/checkExist/${params?.value}`, undefined, { ...option })
}
